// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lG-z","twoColumnImage":"mG-z"};